import { recordPath, recordRoute } from '@/shared/registry'

/** Where the organization pages live. */
export const organizationsPath = '/site-management/organizations'
export const createOrganizationPath = `${organizationsPath}/new`
export const organizationTreePath = `${organizationsPath}/tree`
export const organizationRoute = recordRoute('site-management', 'organizations')
export const editOrganizationRoute = `${organizationRoute}/edit`

/** An organization's details page. */
export function organizationPath(id: string): string {
  return recordPath('site-management', 'organizations', id)
}

/** Create Organization, under a parent when one is given. */
export function createChildPath(parentId: string): string {
  return `${createOrganizationPath}?${new URLSearchParams({ parent: parentId }).toString()}`
}

/** A panel slot on Create and Edit Organization's Basic Information: contributed fields, each saving itself. */
export const organizationBasicFieldsSlot = 'site-management.organization-form.basic.fields'

/** Sections other features add to Create and Edit Organization, each saving itself, a settings group or not. */
export const organizationFormSectionsSlot = 'site-management.organization-form.sections'

/** The API's organization endpoints. */
export const organizationsApi = '/site-management/v1/organizations'

export function organizationApi(id: string): string {
  return `${organizationsApi}/${encodeURIComponent(id)}`
}

/** Moves an organization to another site; `/preview` shows what that takes and what stops it. */
export function organizationSiteApi(id: string): string {
  return `${organizationApi(id)}/site`
}

/** One level of the site's organization tree: the roots, a parent's children, or the matches of `q`. */
export const organizationTreeApi = `${organizationsApi}/tree`

/** The permissions the organization screens show or hide their actions by. */
export const readOrganizationsPermission = 'site-management.organization-profiles.read'
export const writeOrganizationsPermission = 'site-management.organization-profiles.write'
export const deactivateOrganizationsPermission = 'site-management.organization-profiles.deactivation.write'
export const writeExternalIdPermission = 'site-management.organization-profiles.external-id.write'
export const writeAdministrativeNotesPermission = 'site-management.organization-profiles.administrative-notes.write'
export const readOrganizationTreePermission = 'site-management.organization-tree.read'
export const createOrganizationsPermission = 'site-management.organization-tree.create-child.write'
export const moveOrganizationsPermission = 'site-management.organization-tree.re-parent.write'
export const moveOrganizationsToSitePermission = 'site-management.organization-profiles.site-move.write'

/** The aspect that lets a caller change one settings group of an organization. */
export function writeSettingsPermission(group: string): string {
  return `site-management.organization-profiles.settings-${group}.write`
}
